import React from "react";
import AppBar from "../app-bar/app-bar";
import ProductsPharmacy from "../data-tables-pharmacy/product-tenant-table/products-pharmacy";
import {useUser} from "../providers/user-context";

function FindProducts({navOpen, toggleNav}) {
    const {userFullName, tenantName, tenantType} = useUser();
    return (
        <div style={{ display: 'flex', marginTop: '60px' }}>
            <AppBar userFullName={userFullName} tenantName={tenantName} type={tenantType} navOpen={navOpen} toggleNav={toggleNav}/>
            {tenantType === "PHARMACY" && <ProductsPharmacy navOpen={navOpen} tenantType={tenantType}/>}
        </div>
    );
}
export default FindProducts;
